<div class="view-content-full centered-view" *ngIf="loading">
  <div class="row mb-3">
    <div class="col-12">
      <div>
        <mat-progress-spinner diameter="75" mode="indeterminate" class="d-inline-block"></mat-progress-spinner>
        <div class="fetching-location-progress">{{ 'Intellitrailer.Rental.BookingInfo.LoadingLocationTitle' | translate : 'Fetching location' }}...</div>
        <div class="fetching-location-info" innerHTML="{{ 'Intellitrailer.Rental.BookingInfo.LoadingLocationExplanation' | translate : 'Fetching your location. This can take up to 10 seconds.' }}"></div>
        <div>
          <button mat-raised-button color="primary" (click)="back()">{{ 'Intellitrailer.Rental.DetectLock.Cancel' | translate : 'Cancel' }}</button>
        </div>
      </div>
    </div>
  </div>
</div>

